interface CustomLaneHeaderProps {
  title: string
  totalRegistros: string
}

const CustomLaneHeader: React.FC<CustomLaneHeaderProps> = ({title, totalRegistros}) => {
  return (
    <div className='d-flex align-items-center'>
      <span>{title}</span>
      <div
        className='d-inline-flex align-items-center justify-content-center rounded bg-primary text-white p-2 ms-2'
        style={{width: '35px', height: '20px'}}
      >
        {totalRegistros}
      </div>
    </div>
  )
}

export default CustomLaneHeader
